import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { useRouteSlug } from "@/hooks";
import { AuthService } from "@/services";
import { HeapService } from "@/services/analytics/heap";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import {
  saveResponseUpdateDetailsData,
  setToken
} from "@/redux/actions/authConfig.action";
import { userProfile } from "@/redux/actions/homepage.action";
import { selectGetResponseUpdateDetails } from "@/util/selectors";
import SendOTP from "@/components/modal/modalMobileVerification/sendOtp";
import { SignUpContext } from "../signUp";

const OtpFlow = ({
  verificationPhone,
  otpToken,
  otpResendTimeout,
  backRedirection
}) => {
  const [otpValid, setOtpValid] = useState(true);
  const [otpCode, setOtpCode] = useState("");
  const [sendOtpCount, setSendOtpCount] = useState(0);
  const [showVerifyButtonLoader, setShowVerifyButtonLoader] = useState(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState("");
  const { setResponseData } = useContext(SignUpContext);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const routeSlug = useRouteSlug();
  const { search } = useLocation();

  const onSendOtp = async (e, resend) => {
    setOtpCode("");
    setOtpErrorMessage("");
    setOtpValid(true);
    setSendOtpCount(prevCount => prevCount + 1);

    try {
      const response = await (resend
        ? AuthService.resendOtp({ token: otpToken })
        : AuthService.sendOtp({ token: otpToken }));
      setResponseData(response.data);
    } catch (error) {
      console.error("Error in resending OTP", error);
      setOtpErrorMessage(
        error?.response?.data?.message || "Error in resending OTP"
      );
    }
  };

  const clearOTPData = () => {
    setOtpCode("");
    setOtpErrorMessage("");
    setSendOtpCount(0);
    setOtpValid(true);
  };
  const onVerify = async () => {
    setShowVerifyButtonLoader(true);
    try {
      const response = await AuthService.verifyOtp({
        token: otpToken,
        otp: otpCode
      });
      if (response?.data?.success) {
        clearOTPData();
        setResponseData(response?.data);
        dispatch(saveResponseUpdateDetailsData(response.data));
        dispatch(setToken({ ...response.data, redirect: false }));
        dispatch(userProfile(response.data));
        const customerId =
          response.data?.userProfile?.customerId || response.data?.customerId;
        if (customerId) HeapService.identify(String(customerId));
        history.push({
          pathname: `/${routeSlug}/update-details/`,
          search
        });
      } else {
        setOtpErrorMessage(response?.data?.message);
        setOtpValid(false);
      }
    } catch (error) {
      setOtpErrorMessage(error?.response?.data?.message);
      console.error("Error in verifying OTP", error);
      setOtpValid(false);
    } finally {
      setShowVerifyButtonLoader(false);
    }
  };

  useEffect(() => {
    setOtpErrorMessage("");
    setOtpValid(true);
  }, [otpCode]);

  return (
    <SendOTP
      phone={verificationPhone}
      otp={otpCode}
      handleOTPChange={setOtpCode}
      verifyOtp={onVerify}
      otpValid={otpValid}
      sendOtp={onSendOtp}
      sendOtpCount={sendOtpCount}
      errorMessage={otpErrorMessage}
      showLoader={showVerifyButtonLoader}
      otpResendTimeout={otpResendTimeout}
      isNewSignUp
      handleEditClick={backRedirection}
    />
  );
};

export default OtpFlow;
